/* eslint-disable */
export default {
  confirmation: 'Bevestiging',
  confirmMergeToConference: 'Aan conference call toevoegen?',
  mergeToConference: 'Samenvoegen',
  conferenceCall: 'Conference call',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
